import React, {Component} from 'react';
import {MERCHANT_REPORT, RESPONSE} from '../../resources/constant';
import {Link} from 'react-router-dom';
import {css} from '@emotion/core';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import {getAllFilesByReportTypes, getDBAName,getReportDateList} from '../../Utilities/WSUtil';
import {retentionYears, allMonths, allDays, zeroPad} from '../../Utilities/DatePicker';
import {Row,Col,Form, Modal} from 'react-bootstrap';
import renderHTML from 'react-render-html';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import MerchantPicker from '../../Utilities/MerchantPicker'

const override = css`
display:block;
margin: 0 auto;
border-color: blue;
`

export default class SearchMerchantReport extends Component{
    constructor(props){
        super(props);        
        this.state = {                                 
            cu:JSON.parse(localStorage.getItem(RESPONSE)),                      
            checkedAllReport:false, 
            searchSingleId: '',
            legalName:'',
            dbaName:'',
            btnShow: false,
            btnShow2: false,    
            validated: false,
            fetchMessage:'',
            names:[],
            loading: false,               
            toAllDays: allDays, //Monina added
            fromAllDays: allDays, //Monina added
            allUser:false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.blurChange = this.blurChange.bind(this);        
        this.showMerchantPicker = this.showMerchantPicker.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        
        //Monina start - added
        this.updateToAllDays = this.updateToAllDays.bind(this);
        this.updateFromAllDays = this.updateFromAllDays.bind(this);
        //Monina end - added
    }   


    isInputValid(){
        var dateFrom = new Date(document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value);

        var dateTo = new Date(document.getElementById('toMonth').value+
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value);


        var timeDiff = Math.abs(dateTo.getTime() - dateFrom.getTime());
        var dateDiff = (timeDiff / (1000 * 3600 * 24)) + 1; 
        
        if(this.state.searchSingleId === '' && this.state.checkedAllReport === false){                        
            alert('Merchant ID cannot be null')            
            return false;
        }

        if(!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)){
           
                if(dateFrom > dateTo){
                    alert('Date To must be greater than Date From.')            
                    return false;
                }

            
                if(dateDiff > 31 ){
                    alert('Date range should not exceed to 31 days.');            
                    return false;
                }
            
        }

        if(this.state.fetchMessage!=='' && this.state.searchSingleId !== '' ){
            if(this.state.checkedAllReport === false){
                alert('Please input a valid Merchant ID.');            
                return false;
            }
        }

        return true;
    }

        
    componentWillMount(){            
        this.setState({
            btnShow: this.state.cu.user.allReportAccess,
            btnShow2: this.state.cu.user.allReportAccess,
            names:{legalName: '', corpName: ''},
            fetchMessage:''
        })
    }
    
    
    toggleChange = () => {        
        this.setState({
            checkedAllReport: !this.state.checkedAllReport,
            searchSingleId:'',
            names:{legalName: '', corpName: ''},
            fetchMessage:'',
            btnShow2: !this.state.btnShow2
        });
      }
    
    showMerchantPicker(){
        window.open("#/merchantPicker","","width=700,height=600");
    }
    
    selectMerchantPicker = (mer) =>{
        this.setState({
            fetchMessage:'',
            searchSingleId: mer.id,
            names:{ legalName: mer.corpName, 
                    corpName: mer.dbaName}
        })
    }

    blurChange(e){
        e.preventDefault();
        if(this.state.searchSingleId !== ""){
            // this.setState({loading: true});                
            getDBAName(this.state.cu.user.userId, this.state.searchSingleId).then(response =>             
                ({
                    legalName: `${response.dbaName}`,
                    corpName: `${response.corpName}`
                })                                                
            ).then(names => this.setState({names,fetchMessage:'',loading: false}))                
            .catch(error =>{            
                this.setState({
                    fetchMessage: 
                    `Sorry, the Merchant lD you're searching for does not exist in our system. <br/>
                    Please check the details you selected and try again. `,
                    names:{legalName: '', corpName: ''},
                    loading: false
                })                                             
            })
        }      
    }

    //Monina start - added
    updateToAllDays(e){
        var toYear = document.getElementById('toYear').value;
        var toMonth = document.getElementById('toMonth').value;
        var valYear = (typeof toYear !== 'undefined') ? toYear : 0;
        var valMonth = (typeof toMonth !== 'undefined') ? toMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            toAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateFromAllDays(e){
        var fromYear = document.getElementById('fromYear').value;
        var fromMonth = document.getElementById('fromMonth').value;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            fromAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateAllDays(year, month){
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e,i)=>i+1).forEach(function(value, idx){
            arrResult[idx+1] = value;
        });
        return arrResult;
    }
    //Monina end - added

    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        );
    }
   
    handleSubmit(event) {
        event.preventDefault();                      
        var date_From = document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value;

        var date_To = document.getElementById('toMonth').value +
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value;

        // alert(
        //     this.state.cu.user.userId + " " +
        //     this.state.cu.user.groupId + " " +
        //     "1" + " " +          
        //     "1" + " " +
        //     date_From + " " +
        //     date_To + " " +            
        //     MERCHANT_REPORT + " " +            
        //     this.state.searchSingleId + " " +            
        //     this.state.checkedAllReport
        // )
        
        if(this.isInputValid()){
            // console.log("Valid") 
            this.setState({loading: true});
            
            if(this.state.checkedAllReport && this.state.cu.user.allReportAccess){
                    date_To = date_From;
            }
            

            var today = new Date(),
            date = today.getHours()+":"+today.getMinutes()+":"+today.getSeconds()+"."+today.getMilliseconds();
            // console.log("REQUEST TIME:  "+date);
                getAllFilesByReportTypes(                      
                    this.state.cu.user.userId,
                    this.state.cu.user.groupId,
                    "1",          
                    "1",
                    date_From,
                    date_To,            
                    MERCHANT_REPORT,            
                    this.state.searchSingleId,            
                    this.state.checkedAllReport
                ).then(response => {
                    this.props.getTypeReport(MERCHANT_REPORT); 
                    this.props.getReports(response);            
                    this.setState({loading: false});

                    var today = new Date(),
                    date = today.getHours()+":"+today.getMinutes()+":"+today.getSeconds()+"."+today.getMilliseconds();
                    // console.log("REPLY TIME:  "+date);
                }).catch(error =>{            
                    this.setState({
                        fetchMessage: 'Invalid Merchant ID', loading:false,
                    })                                     
                
                })  
        }

    }

    render(){
        
        const {validated } = this.state.searchSingleId;     
        const {legalName, corpName} = this.state.names;    
        return(                               
	        <div>                             
             <BodyHeaderDiv>
                    <BodyHeaderText style={{fontSize:'12px', fontWeight:'bold'}}>Search Merchant Reports</BodyHeaderText>
            </BodyHeaderDiv>
            <ContentDiv>
            <Row >
                <Col>
                <Row>
                    <Col>
                    <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                    {renderHTML(this.state.fetchMessage)}
                    </span>
                    </Col>
                </Row>
                <Row>
                    <Col md={3} ></Col>                    
                    <Col md={6} >
                        <Form onSubmit={this.handleSubmit} validated={validated}>                          
                        <Form.Label size='sm' style={{fontWeight:'bold'}}> {this.props.m} View Report for one (1) Merchant ID</Form.Label>
                        <Form.Row>                        
                            <Form.Group as={Col}  sm={this.state.btnShow?12:11} xs={this.state.btnShow?12:11} controlId="searchSingleId" onChange={this.handleChange} onBlur={this.blurChange}>
                                {/* <Form.Control size='sm' type="text" value={this.state.searchSingleId} disabled={this.state.checkedAllReport} maxLength={10}></Form.Control> */}
                                <Form.Control size='sm' type="text" value={this.state.searchSingleId} disabled={this.state.checkedAllReport} maxLength={10}></Form.Control>
                            </Form.Group>        
                            <Form.Group  as={Col} xs={this.state.btnShow?0:1}  hidden={this.state.btnShow}>                            
                                {/* <Link to='/merchSearchRep' onClick={this.showMerchantPicker}><MidCifBtn>...</MidCifBtn></Link> */}
                                <Form.Group  as={Col} xs={this.state.btnShow2?0:1}  hidden={this.state.btnShow2}>
                                    <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker} />
                                </Form.Group>
                            </Form.Group>                                                                                        
                        </Form.Row>
                        
                        <Form.Label size='sm' style={{fontWeight:'bold'}}>Report Date From</Form.Label>
                        <Form.Row>                                                
                            <Form.Group as={Col} controlId="fromMonth" onChange={this.updateFromAllDays}>                                                            
                                <Form.Control as="select" size='sm'>
                                {   allMonths.map((option, index) =>                             
                                    <option key={index} value={option.id}>{option.month}</option> )  
                                }                              
                                </Form.Control>                                                                
                            </Form.Group>  
                            <Form.Group as={Col} controlId="fromDay" onChange={this.handleChange}>                                                                                            
                                <Form.Control as="select" size='sm'>
                                {   this.state.fromAllDays.map((option, index) =>                                 
                                    <option key={index} value={zeroPad(option,2)}>{option}</option>)
                                }                             
                                </Form.Control>                                                                
                            </Form.Group>
                            <Form.Group as={Col} controlId="fromYear" onChange={this.updateFromAllDays}>                                                                                            
                                <Form.Control as="select" size='sm'>
                                {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                                                                              
                                    <option key={index} value={option}>{option}</option>)
                                }                            
                                </Form.Control>                                                                
                            </Form.Group>                                                         
                        </Form.Row>
                        
                        {/* <Form.Label size='sm' style={{fontWeight:'bold'}}>To</Form.Label> */}
                        {/* <Form.Row > */}
                        <Form.Label size='sm' style={{fontWeight:'bold'}} hidden={this.state.checkedAllReport?this.state.btnShow?true:false:false} >To</Form.Label>
                        <Form.Row hidden={this.state.checkedAllReport?this.state.btnShow?true:false:false}>
                            <Form.Group as={Col} controlId="toMonth" onChange={this.updateToAllDays}>
                                <Form.Control as="select" size='sm' >
                                {   allMonths.map((option, index) =>
                                    <option key={index} value={option.id}>{option.month}</option>)                          
                                } 
                                </Form.Control>                            
                            </Form.Group>
                            <Form.Group as={Col} controlId="toDay" onChange={this.handleChange}>
                                <Form.Control as="select" size='sm' >
                                {   this.state.toAllDays.map((option, index) => 
                                    <option key={index} value={zeroPad(option,2)}>{option}</option>)
                                } 
                                </Form.Control>                            
                            </Form.Group>
                            <Form.Group as={Col} controlId="toYear" onChange={this.updateToAllDays}>
                                <Form.Control as="select" size='sm' >
                                {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                   
                                    <option key={index} value={option}>{option}</option>)
                                } 
                                </Form.Control>                            
                            </Form.Group>
                        </Form.Row>
                        
                        <Form.Row>
                            <Form.Group as={Col} controlId="legalName" onChange={this.handleChange}>
                                <Form.Label size='sm' style={{fontWeight:'bold'}}>Legal Name</Form.Label>
                                <Form.Control type="text" value={legalName} size='sm' disabled></Form.Control>
                            </Form.Group>
                        </Form.Row>

                        <Form.Label size="sm" style={{fontWeight:'bold'}}>DBA Name</Form.Label>
                        <Form.Row>
                            <Form.Group as={Col} sm={this.state.btnShow?12:11} xs={this.state.btnShow?12:11} controlId="dbaName" onChange={this.handleChange}>                            
                                <Form.Control type="text" value={corpName} size='sm' disabled></Form.Control>                            
                            </Form.Group>
                            
                            <Form.Group as={Col} xs={this.state.btnShow?0:1} style={{paddingTop:'3px'}}  hidden={this.state.btnShow}>
                                <Form.Group  as={Col} xs={this.state.btnShow2?0:1}  hidden={this.state.btnShow2}>                                                            
                                    <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                                </Form.Group>
                            </Form.Group> 
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="checkedAllReport" onChange={this.toggleChange}>
                                <Form.Check size='lg' label='View Reports for Multiple Merchant IDs' style={{fontWeight:'bold'}}/>                                                                                                                                            
                            </Form.Group>
                        </Form.Row>        
                        
                        

                        <div align="center">
                        <Col hidden={!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)} >
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                                Users with access to all MIDs are limited to single date search. Please select a date.
                        </span>
                        </Col>
                        <SubmitBtn style={{color:'#FFFFFF'}}>View Report</SubmitBtn> 

                        
                        </div>
                    </Form>                     
                    </Col>
                    <Col md={3} ></Col>
                </Row>
                </Col>                                                   
            </Row>   
            </ContentDiv>          
                <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>                               
            </div>





        )
    }
}


